<template>
    <DadosFinanceirosShared ref="dadosFinanceirosShared" tipoCliente="Pessoa Física" :Edicao="Edicao" />
</template>

<script>
import DadosFinanceirosShared from '@/views/Cadastro/Shared/DadosFinanceiros.vue'

export default {
    name: 'CadastroPF_DadosFinanceiros',
    components: { DadosFinanceirosShared },
    props: ['Edicao'],
    methods: {
        proximaEtapa() {
            if (this.$refs.dadosFinanceirosShared?.proximaEtapa) {
                this.$refs.dadosFinanceirosShared.proximaEtapa();
            }
        }
    }
}
</script>
